import { useState, memo } from 'react';
import { MEMBERSHIP_GROUP } from '../../../Domain/Settings/Constants/Constants';
import CustomDivider from '../../Atoms/CustomDivider/CustomDivider';
import CustomToggle from '../../Atoms/CustomToggle/CustomToggle';
import Spinner from '../../Atoms/Spinner/Spinner';
import MembershipCard from '../TelepresencePurchaseCard/MembershipCard';
import './MembershipSection.css';

const MembershipSection = ({
  parameters,
  membershipList,
  scrollToCourseCard = () => {},
  handleBuy = () => {},
  isTraining,
  schedulerNone = false,
  scrollContainerRef,
  nameMembershipsGroup = { nameMembershipsGroup },
  showBtnsMemberships = false,
  handleGroupMembership = () => {},
  schedulerId = false,
  modeId = false,
  setCurrentSelectMembership = () => {},
  handleUpdateSelection = () => {}
}) => {
  return (
    <section className="py-4 justify-content-center">
      <div className="d-flex text-center justify-content-between pb-2">
        <CustomDivider style={{ width: '15%' }} />
        <div className="d-flex flex-column">
          <h2 style={{ color: 'var(--corporative-yellow)' }} className="lt-text-title text-center">
            {parameters?.MEMBERSHIPS_TITLE?.value || parameters?.MEMBERSHIPS_TITLE_COMPANY?.value || <Spinner />}
          </h2>
          <span className="lt-text-subtitle text-white">
            {parameters?.MEMBERSHIPS_TITLE?.description_value || parameters?.MEMBERSHIPS_TITLE_COMPANY?.description_value}
          </span>
        </div>

        <CustomDivider style={{ width: '15%' }} />
      </div>

      <div className="container py-4">
        {showBtnsMemberships && (
          <div className="text-center pb-3 mb-3">
            <CustomToggle
              setCurrentSelectMembership={setCurrentSelectMembership}
              handleUpdateSelection={handleUpdateSelection}
              schedulerId={schedulerId}
              modeId={modeId}
              parameters={parameters}
              // setGrout={setgroupMembership}
              nameMembershipsGroup={nameMembershipsGroup}
              handleGroupMembership={handleGroupMembership}
            />
          </div>
        )}
        <div
          ref={scrollContainerRef}
          className="d-flex flex-start scroll-container gap-3 justify-content-md-center justify-content-start pb-3"
          style={{
            background: 'black'
          }}
          controls={null}>
          {membershipList &&
            membershipList
              .sort((a, b) => {
                const orderA = a.order_membership || 0;
                const orderB = b.order_membership || 0;
                return orderA - orderB;
              })
              .map((membership, index) => {
                return (
                  <MembershipCard
                    handleBuy={handleBuy}
                    key={index}
                    parameters={parameters}
                    membership={membership}
                    isTraining={isTraining}
                    scrollToCourseCard={scrollToCourseCard}
                    schedulerNone={schedulerNone}
                  />
                );
              })}
        </div>
      </div>
    </section>
  );
};

export default memo(MembershipSection);
